import Request from '@/requests/Request'

const resource = "/projetos/{projetoId}/prestacao-contas";

export default {
  findById(projetoId, prestacaoContaId) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.get(`${url}/${prestacaoContaId}`)
  },

  findByParentId(projetoId) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.get(url)
  },

  post(projetoId, prestacaoConta, file) {
    prestacaoConta.periodo = prestacaoConta.periodo.join("; ")
    
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    delete prestacaoConta['data'];
      
    let formData = new FormData();
    formData.append("prestacaoContaJson", JSON.stringify(prestacaoConta));    
    formData.append("file", file);
    return Request.post(`${url}`, formData)
  },

  editar(projetoId, prestacaoConta, file) {
    prestacaoConta.projeto = null
    prestacaoConta.responsavel = null
    prestacaoConta.organizacao = null
    prestacaoConta.responsavelParecer = null
    delete prestacaoConta['data'];

    if(prestacaoConta.monitoramentoFinanceiro){
      prestacaoConta.monitoramentoFinanceiro.responsavel = null
    }

    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    let formData = new FormData();
    formData.append("prestacaoContaJson", JSON.stringify(prestacaoConta));    
    formData.append("file", file);

    return Request.put(`${url}/${prestacaoConta.id}`, formData)
  },
  
  postMonitoramentoFinaceiro(projetoId, prestacaoContaId, monitoramentoFinanceiro, file) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

      let formData = new FormData();
      formData.append("monitoramentoFinanceiroJson", JSON.stringify(monitoramentoFinanceiro));    
      formData.append("file", file);

      return Request.post(`${url}/${prestacaoContaId}/monitoramento`, formData)
  },

  editarMonitoramentoFinaceiro(projetoId, prestacaoContaId, monitoramentoFinanceiro, file) {
    monitoramentoFinanceiro.responsavel = null
    delete monitoramentoFinanceiro['data'];

    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    let formData = new FormData();
    formData.append("monitoramentoFinanceiroJson", JSON.stringify(monitoramentoFinanceiro));    
    formData.append("file", file);

    return Request.put(`${url}/${prestacaoContaId}/monitoramento`, formData)
  },

  putManifestacao(projetoId, prestacaoContaId, observacoes, file) {

    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    let formData = new FormData();
    formData.append("observacoes", observacoes);
    formData.append("file", file);

    return Request.put(`${url}/${prestacaoContaId}/manifestacao`, formData)
  },  

  putParecer(projetoId, prestacaoContaId, parecer, observacoes, file) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)
      let formData = new FormData();
      formData.append("parecer", parecer);
      formData.append("observacoes", observacoes);
      formData.append("file", file);
  
      return Request.put(`${url}/${prestacaoContaId}/parecer`, formData)
  },

  putArquivos(payload) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)
      .concat('/').concat(payload.prestacaoContaId).concat(payload.url)

    let formData = new FormData();
    formData.append("file", payload.file, payload.file.name);

    return Request.post(`${url}`, formData)
  },

  downloadArquivo(payload) {
    let url = "/storage/{projetoId}/download/{arquivoId}"
    .replace(new RegExp("{projetoId}", "g"), payload.projetoId)
    .replace(new RegExp("{arquivoId}", "g"), payload.arquivoId)

    return Request.get(url, {responseType: 'arraybuffer'}).then(function(response) {
      let blob = new Blob([response.data], { type: response.headers.ContentType })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = response.headers.nomearquivo
      link.click()
    })
  },

  proximaEtapa(projetoId, prestacaoContaId, enviarPara) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

      return Request.get(`${url}/${prestacaoContaId}/${enviarPara}`)
  },

  delete(projetoId, prestacaoContaId) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.delete(`${url}/${prestacaoContaId}`)

  },


}